// parameter slice
import { createSlice } from "@reduxjs/toolkit";
import { firestore } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

const initialState = {
  parameters: [],
  isLoading: false,
  error: false,
};

export const parameterSlice = createSlice({
  name: "paramater",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET parameterS
    getParametersSuccess(state, action) {
      state.isLoading = false;
      state.parameters = action.payload;
    },
    // create Parameter
    createParameterSuccess(state, action) {
      state.parameters.push(action.payload);
    },
    // update Parameter
    updateParameterSuccess(state, action) {
      state.parameters = state.parameters.map((parameter) => {
        if (parameter.id === action.payload.id) {
          return action.payload;
        }
        return parameter;
      });
    },
    // delete Parameter
    deleteParameterSuccess(state, action) {
      const { id } = action.payload;
      state.parameters = state.parameters.filter((parameter) => parameter.id !== id);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  startLoading,
  hasError,
  getParametersSuccess,
  createParameterSuccess,
  updateParameterSuccess,
  deleteParameterSuccess,
} = parameterSlice.actions;

// create Parameter function

export const createParameter = (data) => async (dispatch) => {
  const docRef = collection(firestore, "parameters");
  const newData = {
    ...data,
    timestamp: serverTimestamp(),
  };
  try {
    dispatch(startLoading());
    const addedDocRef = await addDoc(docRef, newData);
    const id = addedDocRef.id;
    // Update the document with the ID
    const docToUpdate = doc(firestore, "parameters", id);
    await updateDoc(docToUpdate, { id });
    dispatch(createParameterSuccess({ ...newData, id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// update parameter
export const updateParameter = (data) => async (dispatch) => {
  const { id, name, paramsType } = data;
  const docRef = doc(firestore, "parameters", id);
  try {
    dispatch(startLoading());
    await updateDoc(docRef, { name, paramsType });
    dispatch(updateParameterSuccess({ id, name, paramsType }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// delete parameter
export const deleteParameter = (id) => async (dispatch) => {
  const docRef = doc(firestore, "parameters", id);
  try {
    dispatch(startLoading());
    await deleteDoc(docRef);
    dispatch(deleteParameterSuccess({ id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};

// get parameters from firestore
export const getParameters = () => async (dispatch) => {
  try {
    dispatch(startLoading());
    const querySnapshot = await getDocs(collection(firestore, "parameters"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(getParametersSuccess(data));
  } catch (error) {
    dispatch(hasError(error));
  }
};

export default parameterSlice.reducer;
